import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Utility from "../../../../Utility/Utility";


const PaymentInvalid = () => {
    const { search } = useLocation();
    const params = new URLSearchParams(search);

    const amount = params.get("amount") || 0;
    const orderId = params.get("order_id") || 0;
    const currency = params.get("currency") || "₹";
    const transactionId = params.get("transaction_id") || "";

    const containerStyle = {
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f4f6f8",
        fontFamily: "Arial, sans-serif"
    };

    const cardStyle = {
        width: "360px",
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        padding: "30px",
        textAlign: "center",
        boxShadow: "0 10px 25px rgba(0,0,0,0.1)"
    };

    const iconStyle = {
        width: "80px",
        height: "80px",
        margin: "0 auto 20px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "40px",
        color: "#ffffff",
        backgroundColor: "#e74c3c"
    };

    const buttonStyle = {
        width: "100%",
        padding: "12px",
        border: "none",
        borderRadius: "8px",
        fontSize: "16px",
        cursor: "pointer",
        backgroundColor: "#e74c3c",
        color: "#ffffff"
    };

    const infoRowStyle = {
        display: "flex",
        justifyContent: "space-between",
        margin: "8px 0",
        fontSize: "14px",
        color: "#555"
    };

    const infoLabelStyle = {
        fontWeight: "600",
        color: "#333"
    };

    const infoValueStyle = {
        fontWeight: "500",
        color: "#000",
        wordBreak: "break-all"
    };

    return (
        <div style={containerStyle}>
            <div style={cardStyle}>
                <div style={iconStyle}>⚠</div>

                <h2>Payment Invalid</h2>

                <p style={{ color: "#666" }}>
                    The payment of <b>{Utility.getCurrencyValue(amount, currency)}</b> is invalid. Please contact support.
                </p>
                <div
                    style={{
                        marginTop: "20px",
                        padding: "15px",
                        borderRadius: "8px",
                        backgroundColor: "#f8f9fa",
                        border: "1px solid #e0e0e0",
                        textAlign: "left",
                        marginBottom: "10px"
                    }}
                >
                    <div style={infoRowStyle}>
                        <span style={infoLabelStyle}>Booking ID</span>
                        <span style={infoValueStyle}>{orderId}</span>
                    </div>

                    <div style={infoRowStyle}>
                        <span style={infoLabelStyle}>Transaction ID</span>
                        <span style={infoValueStyle}>
                            {transactionId || "N/A"}
                        </span>
                    </div>
                </div>


                <button
                    style={buttonStyle}
                    onClick={() => {
                        const lng = localStorage.getItem('i18nextLng') || 'en';
                        window.location.href = `/${lng}/booking-history?payment_status=invalid`;
                    }}
                >
                     My Bookings
                </button>
            </div>
        </div>
    );
};

export default PaymentInvalid;
